import React from 'react';
import '@panwds/tailwindcss';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../../utils/constants.esm.js';
import 'react-dom';
import { CardFooter } from '../Card/CardFooter.esm.js';

function ModalFooter({ addClassName, ...passThrough }) {
    return React.createElement(CardFooter, { addClassName: `${addClassName || ''} tw-py-3`, ...passThrough });
}

export { ModalFooter };
//# sourceMappingURL=ModalFooter.esm.js.map
